const signupNetworkFieldIDs = {
  defaultFromProfile: 5,
  fieldOnItem: 72,
  fieldOnItem2: 43,
  fieldOnItem3: 74,
  defaultOnThisSignup: 8,
  customFromProfile: 9,
  customOtherSignup: 3,
};

const getExtendedFields = {
  customFieldData: {
    fieldsOnItem: [],
    availableFields: {
      thisSignup: [
        {
          networkFieldID: signupNetworkFieldIDs.defaultOnThisSignup,
          fieldTypeID: 1,
          name: "Text",
          title: "Occupation",
          icon: "briefcase fas",
          visibility: "default",
          required: false,
        },
      ],
      otherSignups: [
        {
          networkFieldID: signupNetworkFieldIDs.customOtherSignup,
          fieldTypeID: 5,
          name: "Picker",
          title: "Is this another network field?",
          icon: "info-circle fas far",
          visibility: "private",
          isCustomField: true,
          configuration: {
            behaviorOptions: { allowMultiple: "true" },
            responseOptions: {
              optionsType: "responseOptionList",
              responseOptionList: [
                { optionListValueID: 22, optionListValue: "Yes" },
                { optionListValueID: 23, optionListValue: "no" },
              ],
            },
          },
          required: false,
        },
      ],
      profiles: [
        {
          name: "Text",
          title: "Favorite Profile Number",
          icon: "heart fas far",
          configuration: [],
          visibility: "private",
          isCustomField: true,
          networkFieldID: signupNetworkFieldIDs.customFromProfile,
          required: false,
          fieldTypeID: 1,
        },
        {
          name: "Address",
          fieldTypeID: 4,
          title: "Address",
          icon: "map-marker-alt fas",
          configuration: {
            type: "address",
            subfields: {
              addr1: {
                isVisible: true,
              },
              addr2: {
                isVisible: false,
              },
              city: {
                isVisible: true,
              },
              state: {
                isVisible: true,
              },
              zip: {
                isVisible: true,
              },
              country: {
                isVisible: true,
              },
            },
            responseOptions: {
              default: {
                city: "Sciota",
                state: "PA",
                country: "US",
              },
            },
          },
          visibility: "default",
          groupID: 7,
          networkFieldID: signupNetworkFieldIDs.defaultFromProfile,
        },
      ],
    },
  },
  success: true,
  isApp: false,
};

export { signupNetworkFieldIDs };
export default getExtendedFields;
